import actionsCatalog from './actions.catalog'
import actionsExhibitedWork from './actions.exhibitedWork'
import actionsExhibition from './actions.exhibition'
import actionsExhibitionSection from './actions.exhibitionSection'
import actionsExhibitor from './actions.exhibitor'
import actionsMap from './actions.map'
import mutations from './mutations'

const actions = Object.assign({},
  actionsCatalog,
  actionsExhibitedWork,
  actionsExhibition,
  actionsExhibitor,
  actionsExhibitionSection,
  actionsMap
)

const search = {
  namespaced: true,
  state: {
    resultsList: [],
    resultsMapDetail: null,
    resultsMap: [],
    resultCatalog: {},
    resultsPeriod: {},
    filters: {
      range: [1800, new Date().getFullYear()]
    },
    totalList: null,
    totalMap: null,
    loadingList: true,
    loadingMap: true,
    loadingCatalog: true,
    loadingPeriod: true,
    error: null
  },
  mutations: mutations,
  actions: actions
}

export default search



// WEBPACK FOOTER //
// ./src/store/search/index.js